<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';
import RbxTextEditor from '../../../shared/reybex/RbxTextEditor';

export default {
  name: 'NewCompanyDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
        name: '',
        street: '',
        zipCode: '',
        city: '',
        country: '',
        phone: '',
        mobile: '',
        fax: '',
        email: '',
        web: '',
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    /* istanbul ignore next */
    this.visible = false;
  },
  methods: {
    ...mapActions('companyDetails', ['saveCompany']),
    ...mapActions('companyList', { fetchData: 'fetchCompanyList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveCompany(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Firma erfolgreich erstellt!');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/company/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Fehler beim Erstellen der Firma. Bitte versuche es erneut!');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neue Firma
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.name"
                :error-messages="validationErrorMessages.name"
                label="Firma"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md8 py-0/>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.street"
                label="Straße"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.zipCode"
                label="PLZ"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.city"
                label="Ort"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.country"
                label="Land"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.phone"
                label="Telefon"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.mobile"
                label="Handy"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.fax"
                label="Fax"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.email"
                label="E-Mail-Adresse"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.web"
                label="Webseite"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.chiefResponsibleJob"
                label="Leiter der verantwortlichen Stelle"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md4 py-0>
              <v-text-field
                v-model="formData.chiefDataProcessing"
                label="Leiter der Datenverarbeitung / IT"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md12 py-0>
              <rbx-text-editor
                label="Kurzprofil der Verantwortlichen Stelle"
                v-model="formData.profileResponsibleJob"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; Neu
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Detail
              </v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
